module.exports = __webpack_public_path__ + "img/Partners.02d9f8e2.png";